import { useCallback } from 'react';
interface ScrollToParameter {
  x: number;
  y: number;
  id?: string;
  behavior?: 'smooth' | 'auto';
}
export function useScrollContent() {
  const scrollTo = useCallback(
    ({ x, y, id = 'frame-content', behavior = 'smooth' }: ScrollToParameter) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollTo({
          top: y,
          left: x,
          behavior,
        });
      }
    },
    [],
  );

  return { scrollTo };
}
